
import ko from 'knockout';
import * as mapping from 'knockout-mapping';
import Filters from '../filters';
import FiltersV3 from '../filtersV3';
import FiltersHorizontalV3 from '../filtersHorizontalV3';
import { initLoadMore } from './load-more';

let json = $("#page-data").text();
let data = mapping.fromJSON(json);

let catJson = $("#category-data").text();
var catData = null;

if (catJson != '')
    catData = JSON.parse(catJson);

let sortByJson = $("#sortby-data").text();
let sortByData = mapping.fromJSON(sortByJson);

let dom = document.getElementById('products-browse');

data.sortBy = function() {
    var x = sortByData();
    return x;
};

// Check if we're using horizontal V3 filters (has the horizontal bar element)
const hasHorizontalFilters = document.getElementById('facetsHorizontalBar');

if (hasHorizontalFilters) {
    // Use horizontal filters for V3
    FiltersHorizontalV3.init(data, sortByData);
} else {
    // Fallback to V2 filters + vertical V3 filters
    Filters.init(data, sortByData);
    FiltersV3.init(data, sortByData);
}

ko.applyBindings(data, dom);

$(".sortByText").html(FiltersHorizontalV3.SortByToFriendly(sortByData()));

$(function()  {
    if (catData != null) {
        (window as any).klaviyo.track("Viewed Category", {
            "CategoryName": catData?.Name,
            "CategoryID": catData?.Id,
            "Slug": catData?.Slug
        }).then(function (e) {
            console.log('tracked category');
        });
    }

    // Initialize load more functionality
    initLoadMore();
})